import { render, staticRenderFns } from "./Senhas.vue?vue&type=template&id=b36def00&"
import script from "./Senhas.vue?vue&type=script&lang=js&"
export * from "./Senhas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports